import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  memberLevelConfigData: {},
  pageFlag: 'create'
}

export const poingtCardSlice = createSlice({
  name: 'memberLevelConfig',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setMemberLevelConfigDataAction: (state, action) => {
      state.memberLevelConfigData = action.payload
    },
    setMemberLevelConfigPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setMemberLevelConfigDataAction, setMemberLevelConfigPageFlagAction } = poingtCardSlice.actions

// Selectors
export const selectMemberLevelConfigData = (state) => state.memberLevelConfig.memberLevelConfigData
export const selectMemberLevelConfigPageFlag = (state) => state.memberLevelConfig.pageFlag

// Reducer
export default poingtCardSlice.reducer